import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ApiResponse, ApiPagedResponse, PaginationInfo } from "app/client-core/api-response-models";
import { ApiService } from "../api.service";
import { Router } from '@angular/router';
import { RetailerDto, RetailerBrandsListItemDto } from '../dtos/retailers.model';
import { Subject } from 'rxjs';
import { StrategicBusinessInitiativeDto } from '../dtos/stratigic-business-initiative';

@Injectable()
export class StrategicBusinessInitiativeService {
    public newStrategicBusinessInitiativeAdded: Subject<any>;
    constructor(private apiService: ApiService,
       private router: Router) {
        this.newStrategicBusinessInitiativeAdded = new Subject<any>();
    }

    /**
     * Returns lookup list of projects
     * @param params
     */
    getStrategicBusinessInitiatives(params?: any): Observable<ApiResponse<ApiPagedResponse<StrategicBusinessInitiativeDto>>> {
        console.log('>>getStrategicBusinesInitiatives', JSON.stringify(params));
        return this.apiService.get<ApiPagedResponse<StrategicBusinessInitiativeDto>>('StrategicBusinesInitiative', params);
    }

    getStrategicBusinessInitiativeToEdit(id) {
        return this.apiService.get(`StrategicBusinesInitiative/edit/${id}`);
    }

    saveStrategicBusinesInitiative(params?: StrategicBusinessInitiativeDto) {
        if (params.id && params.id > 0) {
            return this.apiService.put(`StrategicBusinesInitiative`, params);
        } else {
            return this.apiService.post(`StrategicBusinesInitiative`, params);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/client-core/services/strategic-business-initiative.service.ts